// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(sharedMessageId) {
  return {
          sharedMessageId: sharedMessageId
        };
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_sharedPropertyV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["SharedPropertyV5"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"sharedPropertyV5_SharedPropertyV5_message":{"b":""},"sharedPropertyV5_SharedPropertyV5_contacts_edges_emailStats":{"f":""},"sharedPropertyV5":{"u":"response_sharedPropertyV5"}}};

var wrapResponseConverterMap = {
  response_sharedPropertyV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"sharedPropertyV5_SharedPropertyV5_message":{"b":""},"sharedPropertyV5_SharedPropertyV5_contacts_edges_emailStats":{"f":""},"sharedPropertyV5":{"u":"response_sharedPropertyV5"}}};

var responseConverterMap = {
  response_sharedPropertyV5: unwrap_response_sharedPropertyV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sharedMessageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "sharedMessageId",
    "variableName": "sharedMessageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedPostEmailStatsButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedPropertyV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SharedPropertyV5ContactsConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SharedPropertyV5ContactsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": null,
                          "args": null,
                          "concreteType": "SharedPropertyEmailStatsForRecipient",
                          "kind": "LinkedField",
                          "name": "emailStats",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "SharedPostEmailStatsSingleRecipient_recipient"
                            }
                          ],
                          "storageKey": null
                        },
                        "action": "NONE"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedPropertyV5",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SharedPostEmailStatsButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedPropertyV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SharedPropertyV5ContactsConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SharedPropertyV5ContactsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SharedPropertyEmailStatsForRecipient",
                        "kind": "LinkedField",
                        "name": "emailStats",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v4/*: any*/),
                                "type": "SharingContactClientContactV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v4/*: any*/),
                                "type": "SharingContactFreshContactV5",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastClickedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberOfClicks",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedPropertyV5",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c5f049906d719d90b5d7d802c2ff710",
    "id": null,
    "metadata": {},
    "name": "SharedPostEmailStatsButtonQuery",
    "operationKind": "query",
    "text": "query SharedPostEmailStatsButtonQuery(\n  $sharedMessageId: ID!\n) {\n  sharedPropertyV5(sharedMessageId: $sharedMessageId) {\n    __typename\n    ... on SharedPropertyV5 {\n      message\n      contacts {\n        edges {\n          emailStats {\n            ...SharedPostEmailStatsSingleRecipient_recipient\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SharedPostEmailStatsSingleRecipient_recipient on SharedPropertyEmailStatsForRecipient {\n  contact {\n    __typename\n    ... on SharingContactClientContactV5 {\n      email\n    }\n    ... on SharingContactFreshContactV5 {\n      email\n    }\n  }\n  lastClickedAt\n  numberOfClicks\n  status\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_sharedPropertyV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_sharedPropertyV5 = unwrap_response_sharedPropertyV5;
exports.wrap_response_sharedPropertyV5 = wrap_response_sharedPropertyV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
